import type { Project } from '@portfolio-pm/shared';
import { ScrollViewport } from '../layout/ScrollViewport.tsx';

/** Slide-in project selector for the mobile OKR workspace (REQ-UI-011). */
export function MobileOkrSelector({
  open,
  projects,
  activeProjectId,
  onSelect,
}: {
  open: boolean;
  projects: Project[];
  activeProjectId: string;
  onSelect(projectId: string): void;
}): JSX.Element {
  return (
    <aside
      data-testid="mobile-okr-selector"
      data-open={open || undefined}
      aria-hidden={!open}
      className={`mobile-standalone-safe-top absolute inset-y-0 left-0 z-10 hidden w-[min(82vw,20rem)] flex-col border-r border-[color:var(--app-border)] bg-[color:var(--app-mobile-panel-bg)] px-3 pb-4 shadow-sm transition-transform duration-200 ease-out max-md:flex ${
        open ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <p className="eyebrow-label pt-3">Projects</p>
      <ScrollViewport className="mt-3 min-h-0 flex-1" viewportClassName="h-full pr-1">
        <div className="space-y-1">
          {projects.map((project) => (
            <button
              key={project.id}
              type="button"
              data-testid={`mobile-okr-project-${project.id}`}
              onClick={() => onSelect(project.id)}
              className={`flex w-full items-center rounded-xl px-3 py-2.5 text-left text-sm transition ${
                project.id === activeProjectId
                  ? 'border border-[color:var(--app-border-strong)] bg-[color:var(--app-accent-soft)] font-medium text-[color:var(--app-accent-text)]'
                  : 'text-[color:var(--app-text-muted)] hover:bg-white/70 hover:text-[color:var(--app-text)]'
              }`}
            >
              {project.name}
            </button>
          ))}
        </div>
      </ScrollViewport>
    </aside>
  );
}
